/**
 * Shared product-card behavior: Ajax add-to-cart, cart badge, cart toast,
 * and the quick-view modal (snippets/quick-view-modal.liquid, rendered once
 * globally in theme.liquid). Every section using snippets/card-product.liquid
 * (featured-products, product-grid-filtered) and the product page
 * (main-product.liquid) bind to this single implementation — see
 * shopify-rules.md "No Duplicate Implementations".
 */
(function () {
  'use strict';

  var cartBadge = document.getElementById('cartBadge');
  var cartToast = document.getElementById('cartToast');
  var toastTimer;

  function updateCartBadge(count) {
    if (!cartBadge) return;
    cartBadge.textContent = count;
    cartBadge.classList.remove('bump');
    void cartBadge.offsetWidth;
    cartBadge.classList.add('bump');
  }

  function showToast(message) {
    if (!cartToast) return;
    cartToast.textContent = message;
    cartToast.hidden = false;
    cartToast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      cartToast.classList.remove('is-visible');
      cartToast.hidden = true;
    }, 2600);
  }

  function flashAdded(btn) {
    if (!btn || btn.tagName !== 'BUTTON') return;
    var span = btn.querySelector('span');
    var original = span ? span.textContent : btn.textContent;
    if (span) span.textContent = 'Added ✓'; else btn.textContent = 'Added ✓';
    btn.classList.add('added');
    setTimeout(function () {
      if (span) span.textContent = original; else btn.textContent = original;
      btn.classList.remove('added');
    }, 1600);
  }

  function addToCart(variantId, quantity, triggerBtn) {
    if (!variantId) return;
    if (triggerBtn) triggerBtn.disabled = true;

    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        showToast('Added to cart');
        if (triggerBtn) flashAdded(triggerBtn);
      })
      .catch(function (err) {
        showToast((err && err.description) || 'Could not add that item right now.');
      })
      .finally(function () {
        if (triggerBtn) triggerBtn.disabled = false;
      });
  }

  /* ---- Bind every [data-add-to-cart] button (grid cards, product page) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.closest('form#ProductForm')) return; // product page form submits natively below
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn.dataset.variantId, 1, btn);
  });

  /* ---- Product page form: Ajax-enhance the native product form submit ---- */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var idInput = productForm.querySelector('[name="id"]');
      var qtyInput = productForm.querySelector('[name="quantity"]');
      var submitBtn = productForm.querySelector('[data-add-to-cart]');
      addToCart(idInput ? idInput.value : null, qtyInput ? parseInt(qtyInput.value, 10) : 1, submitBtn);
    });
  }

  /* ---- Quick view modal ---- */
  (function () {
    var overlay = document.querySelector('[data-quick-view-overlay]');
    if (!overlay) return;
    var qvImg = document.getElementById('qvImg');
    var qvCat = document.getElementById('qvCat');
    var qvName = document.getElementById('qvName');
    var qvPrice = document.getElementById('qvPrice');
    var qvDesc = document.getElementById('qvDesc');
    var qvAdd = document.getElementById('qvAdd');
    var qvClose = document.getElementById('qvClose');
    var lastTrigger = null;

    function openQuickView(card) {
      var d = card.dataset;
      if (qvImg) { qvImg.src = d.img || ''; qvImg.alt = d.name || ''; }
      if (qvCat) qvCat.textContent = d.cat || '';
      if (qvName) qvName.textContent = d.name || '';
      if (qvPrice) qvPrice.innerHTML = d.old ? '<span class="old">' + d.old + '</span>' + d.price : (d.price || '');
      if (qvDesc) qvDesc.textContent = d.desc || '';
      if (qvAdd) qvAdd.dataset.variantId = d.variantId || '';
      lastTrigger = card.querySelector('[data-quick-view]');
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      if (qvClose) qvClose.focus();
    }
    function closeQuickView() {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-view]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      var card = trigger.closest('[data-product-card]');
      if (card) openQuickView(card);
    });

    if (qvClose) qvClose.addEventListener('click', closeQuickView);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeQuickView(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('open')) closeQuickView();
    });
    if (qvAdd) {
      qvAdd.addEventListener('click', function () {
        addToCart(qvAdd.dataset.variantId, 1, qvAdd);
      });
    }
  })();
})();
